import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "60",
  height: "60",
  viewBox: "0 0 60 60",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "60",
      height: "60",
      rx: "30",
      fill: "#C1C1C2"
    }, null, -1),
    _createElementVNode("path", {
      d: "M30 15C25.1144 15 21.1538 18.9137 21.1538 23.7416C21.1538 26.666 22.6071 29.255 24.8389 30.8419C19.127 32.3092 15 36.1526 15 40.8024C15 42.1939 16.3628 43.125 17.8846 43.125H42.1154C42.8002 43.125 43.4696 42.9356 43.9954 42.5764C44.6139 42.1538 45 41.517 45 40.8024C45 36.1526 40.873 32.3092 35.1611 30.8419C37.3929 29.255 38.8462 26.666 38.8462 23.7416C38.8462 21.4232 37.9142 19.1997 36.2552 17.5603C34.5962 15.921 32.3461 15 30 15Z",
      fill: "white"
    }, null, -1)
  ]))]))
}
export default { render: render }